import { render, staticRenderFns } from "./work.vue?vue&type=template&id=6a06063e&scoped=true&"
import script from "./work.vue?vue&type=script&lang=ts&"
export * from "./work.vue?vue&type=script&lang=ts&"
import style0 from "./work.vue?vue&type=style&index=0&id=6a06063e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a06063e",
  null
  
)

export default component.exports